import { Stack } from '@mui/material';
import { StyledTextField } from 'modules/components/layer01';
import { FormBaseLayout } from 'modules/components/layer10';
import React from 'react';
import * as ds from './dataService';
import { authUtil } from 'modules/common';


export type ForgotPasswordFormProps = {
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ForgotPasswordFormProps) => {
  const form = ds.useFormState();

  const handleSubmit = async (data: ds.IFormState) => {
    if (form.formState.step === 1) {
      try {
        form.dispatch({
          type: 'UPDATE',
          payload: {
            property: 'isLoading',
            value: true
          }
        });
        await authUtil.resetPassword(form.formState.email);
        form.dispatch({
          type: 'BATCH_UPDATE',
          payload: {
            ...data,
            step: 2,
            isLoading: false
          }
        });
      } catch (error) {
        window.alert(error);
      }

    } else if (form.formState.step === 2) {
      form.dispatch({
        type: 'UPDATE',
        payload: {
          property: 'step',
          value: 3
        }
      });

    } else if (form.formState.step === 3) {
      form.dispatch({
        type: 'UPDATE',
        payload: {
          property: 'isLoading',
          value: true
        }
      });
      try {
        await authUtil.confirmResetPassword({
          email: form.formState.email,
          password: form.formState.password,
          confirmationCode: form.formState.code.trim()
        });
        form.dispatch({
          type: 'UPDATE',
          payload: {
            property: 'isLoading',
            value: false
          }
        });
        window.alert('Your password has been reset.');
        props.handleClose();

      } catch (error) {
        window.alert(error);
      }

    }
  };
  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={async () => {
        await handleSubmit(form.formState);
      }}
      ignoreCancel={true}
      successButtonText={step2SuccessText[form.formState.step]}
      isLoading={form.formState.isLoading}
    >
      <Stack
        rowGap='2rem'
        paddingBottom='2rem'
      >
        {step2Fields[form.formState.step].map((field, i) => (
          <StyledTextField.FC
            key={i}
            {...form.genFieldProps(field)}
          />
        ))}
      </Stack>
    </FormBaseLayout.FC>
  );
};


const step2Fields: Record<number, (keyof ds.IFormState)[]> = {
  1: ['email'],
  2: ['code'],
  3: [
    'password',
    'confirmPassword'
  ]
};

const step2SuccessText: Record<number, string> = {
  1: 'Send Email',
  2: 'Next',
  3: 'Reset Password'
};
